import api, {setHeaderToken} from "./api";

function getApiBaseURL() {
    return api.defaults.baseURL || window.location.origin;
}

export function getAdminCollectionURL(uid, documentId) {
    const collectionURL = new URL(`../content-manager/collection-types/${uid}`, getApiBaseURL()).toString();
    return documentId ? `${collectionURL}/${documentId}` : collectionURL;
}

export function getAdminSingleTypeURL(uid) {
    return new URL(`../content-manager/single-types/${uid}`, getApiBaseURL()).toString();
}

export function normalizeCollectionResponse(payload) {
    const items = Array.isArray(payload)
        ? payload
        : (payload?.results || payload?.data || []);
    const total = payload?.pagination?.total
        ?? payload?.meta?.pagination?.total
        ?? payload?.total
        ?? items.length;

    return {items: Array.isArray(items) ? items : [], total: Number(total) || 0};
}

export function normalizeEntityResponse(payload) {
    return payload?.data || payload?.result || payload || null;
}

export async function fetchAdminCollection(uid, params = {}) {
    const {data} = await api.get(getAdminCollectionURL(uid), {
        params: {
            page: 1,
            pageSize: 100,
            sort: "createdAt:DESC",
            ...params,
        },
    });
    return normalizeCollectionResponse(data);
}

export async function fetchAllAdminCollection(uid, params = {}) {
    const requestedPageSize = Number(params.pageSize) || 100;
    const pageSize = Math.max(1, Math.min(requestedPageSize, 200));
    const maxPages = Math.max(1, Number(params.maxPages) || 25);
    const baseParams = {...params};
    delete baseParams.maxPages;

    const items = [];
    let total = 0;

    for (let page = 1; page <= maxPages; page += 1) {
        const result = await fetchAdminCollection(uid, {...baseParams, page, pageSize});
        items.push(...result.items);
        total = result.total;
        if (result.items.length < pageSize || items.length >= total) break;
    }

    return {items, total: Math.max(total, items.length)};
}

export async function fetchAdminEntity(uid, documentId) {
    const {data} = await api.get(getAdminCollectionURL(uid, documentId));
    return normalizeEntityResponse(data);
}

export async function fetchAdminSingleType(uid) {
    const {data} = await api.get(getAdminSingleTypeURL(uid));
    return normalizeEntityResponse(data);
}

export async function createAdminEntity(uid, payload) {
    const {data} = await api.post(getAdminCollectionURL(uid), payload);
    return normalizeEntityResponse(data);
}

export async function updateAdminEntity(uid, documentId, payload) {
    const {data} = await api.put(getAdminCollectionURL(uid, documentId), payload);
    return normalizeEntityResponse(data);
}

export async function saveAdminSingleType(uid, payload) {
    const {data} = await api.put(getAdminSingleTypeURL(uid), payload);
    return normalizeEntityResponse(data);
}

export async function deleteAdminEntity(uid, documentId) {
    const {data} = await api.delete(getAdminCollectionURL(uid, documentId));
    return normalizeEntityResponse(data);
}

export function restoreAdminToken(user) {
    if (user?.jwt) setHeaderToken(`Bearer ${user.jwt}`);
}
